import { takeLatest, put, call, all } from "redux-saga/effects";
import FaqActionTypes from "./faq.types";
import { firestore } from "../../utils/firebase/firebase.util";
import { fetchFaqsSuccess, fetchFaqsFailure } from "./faq.actions";

export function* fetchFaqsAsync() {
  try {
    const faqRef = firestore.collection("faqs");
    const snapShot = yield faqRef.get();
    const transformedFaqs = yield snapShot.docs.map((doc) => {
      return { id: doc.id, ...doc.data() };
    });
    yield put(fetchFaqsSuccess(transformedFaqs));
  } catch (error) {
    yield put(fetchFaqsFailure(error));
  }
}

export function* onFetchFaqs() {
  yield takeLatest(FaqActionTypes.FETCH_FAQS_START, fetchFaqsAsync);
}

export function* faqSagas() {
  yield all([call(onFetchFaqs)]);
}
